<div class="sample-answer">
  <qa-form-field-input
    [control]="form.get('textBoxData')"
    [markdownHint]="true"
    (blurEvent)="handleTextBoxTextChange($event)"
    [multi]="true"
    class="name-input"
    data-cy="question"
  ></qa-form-field-input>
</div>
